import React, {useEffect, useState} from 'react';
import {businessAPI} from './api/BusinessApi';
import {Business} from './Business';
import BusinessList from './BusinessList';
import {Alert, Container, Snackbar} from "@mui/material";

function MainPage(props: any) {
    const [businesses, setBusinesses] = useState<Business[]>([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [error, setError] = useState<string | undefined>(undefined);
    const [success, setSuccess] = useState<string | undefined>(undefined);
    const adminName = props.adminName;
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    const sort = (a: Business, b: Business) => {
        const nameA = a.shopNumber.toUpperCase(); // ignore upper and lowercase
        const nameB = b.shopNumber.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // names must be equal
        return 0;
    };
    const saveBusiness = (business: Business) => {
        console.log('Saving project: ', business);
        setError('');
        if (business.id) {
            businessAPI
            .put(business)
            .then((updatedBusiness) => {
                let updatedBusinesses = businesses.map((p: Business) => {
                    return p.id === business.id ? business : p;
                });
                setBusinesses(updatedBusinesses.sort(sort));
                setSuccess('Updated Successfully!');
                setOpen(true);
            })
            .catch((e) => {
                if (e instanceof Error) {
                    setError(e.message);
                    setOpen(true);
                }
            });
        } else {
            businessAPI
            .create(business)
            .then((updatedBusiness) => {
                businesses.pop();
                businesses.push(updatedBusiness);
                setBusinesses([...businesses].sort(sort));
                setSuccess('Created Successfully!');
                setOpen(true);
            })
            .catch((e) => {
                if (e instanceof Error) {
                    setError(e.message);
                    setOpen(true);
                }
            });
        }

    }

    const addBusiness = () => {
        businesses.push(new Business());
        setBusinesses([...businesses]);
    }
    const cancelAdd = () => {
        businesses.pop();
        setBusinesses([...businesses]);
    }

    useEffect(() => {
        async function loadProjects() {
            setLoading(true);
            try {
                const data = await businessAPI.get(1);
                setError('');
                setBusinesses(data.sort(sort));
            }
            catch (e) {
                if (e instanceof Error) {
                    setError(e.message);
                }
            } finally {
                setLoading(false);
            }
        }
        loadProjects();
    }, []);

    return (
        <Container style={{
            minWidth: "100%",
            height: "100vh",
        }}>
            {/*{error && (*/}
            {/*    <Alert severity="error" sx={{ display: "flex", width: '100%', justifyContent: "center" }}>{error}</Alert>*/}
            {/*)}*/}
            {!loading &&
                <BusinessList businesses={businesses} setError={setError} cancelAdd={cancelAdd}
                              addBusiness={addBusiness} onSave={saveBusiness}
                              adminName={adminName}/>
            }
            {loading && (
                <div className="center-page">
                    <span className="spinner primary"></span>
                    <p>Loading...</p>
                </div>
            )}

            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={error ? "error" : "success"}
                       sx={{width: '100%'}}>
                    {error ? error : success}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default MainPage;